import { useQuery } from "@tanstack/react-query";
import { fetchUserDetails } from "../services/usersServices"

export const useUserDetails = (email) => {
  return useQuery({
    queryKey: ["userDetails", email],
    queryFn: fetchUserDetails,
    enabled: !!email, 
  });
};
